/**
 * Featured collection / Best Sellers — Add to Cart handler
 *
 * Adds the clicked product's variant via the Cart AJAX API (cart/add.js),
 * refreshes the Impact theme cart drawer section markup, then opens it.
 *
 * IMPORTANT: The drawer refresh/open logic assumes Impact's cart drawer is
 * rendered as a <cart-drawer> custom element from a section literally named
 * "cart-drawer" (sections/cart-drawer.liquid), which is the standard
 * Maestrooo/Impact pattern. If your theme build renamed the section or
 * exposes a different open method/event, update refreshCartDrawer() and
 * openCartDrawer() below to match — check assets/cart-drawer.js (or similar)
 * in your theme for the exact element name and public API.
 */
(function () {
  'use strict';

  // Homepage can render this section more than once; each instance loads this
  // asset. Guard so we only bind one document click listener.
  if (window.__nsFeaturedCollectionAtc) return;
  window.__nsFeaturedCollectionAtc = true;

  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-add-to-cart]');
    if (!button) return;
    if (button.disabled || button.getAttribute('aria-busy') === 'true') return;

    event.preventDefault();
    event.stopPropagation();
    addToCart(button);
  });

  async function addToCart(button) {
    const variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;

    const textEl = button.querySelector('[data-add-to-cart-text]');
    const originalText = textEl ? textEl.textContent : '';
    const addingLabel = button.getAttribute('data-adding-label') || 'Adding...';

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.classList.add('is-loading');
    if (textEl) textEl.textContent = addingLabel;

    try {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: 1 }]
        })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.description || 'Could not add product to cart');
      }

      await refreshCartDrawer();
      openCartDrawer();
    } catch (error) {
      console.error('[Featured collection] Add to cart failed:', error);
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.classList.remove('is-loading');
      if (textEl && textEl.textContent === addingLabel) {
        textEl.textContent = originalText;
      }
    }
  }

  /**
   * Re-renders the cart-drawer section via the Section Rendering API so the
   * newly added line item shows up before the drawer opens.
   */
  async function refreshCartDrawer() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    try {
      // Prefer Impact's own refresh path when available.
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      return;
    } catch (error) {
      console.error('[Featured collection] Could not refresh cart drawer:', error);
    }
  }

  /**
   * Opens Impact's cart drawer.
   */
  function openCartDrawer() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    if (typeof cartDrawer.show === 'function') {
      cartDrawer.show();
      return;
    }

    if (window.__piThemeCart && typeof window.__piThemeCart.scheduleOpenDrawer === 'function') {
      window.__piThemeCart.scheduleOpenDrawer();
      return;
    }

    cartDrawer.setAttribute('open', '');
  }
})();
